import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/edinburg")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Edinburg, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Edinburg & Hidalgo County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Edinburg, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Edinburg and Hidalgo County.",
      keywords: "awnings Edinburg, awning company Edinburg, custom awnings Edinburg, sail shades Edinburg, patio covers Edinburg, pergola covers Edinburg, metal awnings Edinburg, canvas awnings Edinburg, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Edinburg", "Hidalgo County"),
  }),
  component: () => <CityHomePage city="Edinburg" region="Hidalgo County" />,
});
